import ModuleMixin from "../ModuleMixin";
import SnapshotModule from "../../../Snapshot/SnapshotModule/SnapshotModule.vue";
import SnapshotIcon from "../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "Personenzahl",
  components: {
    SnapshotModule,
    SnapshotIcon,
  },
  mixins: [
    ModuleMixin,
  ],
  computed: {
    optionsFormstepDetailLocal() {
      const OPTIONS = cloneDeep(this.optionsFormstepDetail);
      OPTIONS.list = [
        {
          id: "personenzahl",
          htmlId: `${ this.htmlRegelNummer }_personenzahl`,
          type: "integer",
          label: this.modelParameter.frage,
          required: this.parameterObj.frage && this.parameterObj.frage.required,
          view: "v",
          editonly: true,
          startupFocus: true,
        },
      ];
      return OPTIONS;
    },

    labelHeader() {
      return "_TXT_GR_PERSONENZAHL_HEADER_";
    },

    statusDiff() {
      if (!this.snapshotModule) {
        return false;
      }
      return this.snapshotModule.personenzahl !== this.model.personenzahl;
    },
  },
  methods: {
    prepareModel() {
      this.model = cloneDeep(this.module.data) || {};
    },
  },
};
